/*
saikrishna 11/15/2022 2701012930 Added stepper and created this component
Ashraf 11/18/2022 2701012930 set category state for prepopulation
Sai maheshwar 11/20/2022 2701012930 hide fieldList step for calculate only fields
Suresh Peddavoora 11/22/2022 2701012930 - Fixed Spacing Alignments for Search Formula Rule Button.
lalitha 11/23/2022 2701012930 added completed styles in stepper
Ashraf 11/24/2022 2701012930 moving directly into steps when its not in draft
akhila 11/24/2022 2701012930 implemented animations to completed step
akhila 11/24/2022  2701012930 changed background color for selected step
Dilip 12/05/2022  2701012930 Removed unecesarry console.log statements
lalitha 12/08/2022 2701012930 Renamed stepper
Lalitha 12/09/2022  2701012930 Added reusable backButtonText
Poornima 12/09/2022 2701012930 Added download configurations buttons
Akhila 12/09/2022 2701012930 fixed session saerch issue
akhila 12/14/2022 2701012930 changed label
kavyareddy 12/15/2022 2701012930 Added role disable condition
Ashraf 15/16/2022 2701012930 fixed role access
akhila 12/18/2022 2701012930 added unsaved changes popup
Prakash 12/21/2022 2700753823 Adjusted Padding Alignment.
saikrishna 01/04/2023 2700753823 changed the sourceType formula rule  to data calculations
Akhila 01/18/2023 2700753823 unsaved changes popUp back button and stepper issue fix
Akhila 01/19/2023 2700753823 save and Next bugFix
manikanta 01/27/2023 2700753823 passed printIndividual to payload
Sai maheshwar 01/31/2023 2700753823 fixed data calculations stepper issue
Raghu 02/21/2023 2700753823 changed stepper colors
Akhila 02/24/2023 2700753823 implemented preview file functionality in download configuration
Akhila 03/01/2023 2700753823  Added loader and download toast message for preview File
Sohel 03/10/2023 2700753823 added StepIconComponent for showing Numbers in StepLabel
Ravi 06/09/2023 2700753823 Added Breadcrums in preview

*/
import { Button, makeStyles, Stepper, StepLabel, Step } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActionRule from './ActionRule';
import BasicInfoRule from './BasicInfoRule';
import MapFieldRule from './MapFieldRule';
import StepConnector from '@material-ui/core/StepConnector';
import { withStyles } from '@material-ui/core/styles';
import { backButtonText, downloadButton } from '../../../../../util/Content';
import { postPrintUsage } from '../../../../../redux/reducers/printUsage';
import {
  postFormulaRuleGroup,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import PageLoader from '../../../../../components/PageLoader';
import useUnsavedChangesWarning from './../../../../../util/CustomHooks';
import { setAlertData } from '../../../../../redux/reducers/UnsavedChangesAlertReducer';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import axios from 'axios';
import { resetDownloadMsg } from '../../../../../redux/reducers/PreviewFileData';
import NumberStepIcon from '../../../../../components/customStepIcon';
import reusableInputStyles from '../../../../../components/InputStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepperCard: {
    padding: '16px 8px',
  },
  stepperButtons: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '10px 0 0',
  },
  stepperIcon: {
    '& .MuiStepLabel-iconContainer': {
      '& .MuiStepIcon-root': {
        width: '35px !important',
        height: '35px !important',
      },
    },
    '& .MuiStepIcon-completed': {
      color: '#056c93',
    },
    '& .MuiStepIcon-active': {
      color: '#056c93',
    },
    '& .MuiStepLabel-labelContainer': {
      '& .MuiTypography-root': {
        fontSize: '1rem',
        fontWeight: 600,
        fontFamily: 'articulat-cf, sans-serif !important',
      },
    },
  },
}));
const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);
const RuleGroup1 = ({ setValue, setSelectedBaseCategory, editExisting }) => {
  const { basicInfoData, configurationUrl, dockey } = useSelector(
    ({ addRuleGroup }) => addRuleGroup,
  );
  const stepperClasses = useStyles();
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [steps, setSteps] = useState(['Basic Info', 'Field List', 'Add Calculation Rules']);
  const [activeStep, setActiveStep] = React.useState(0);
  const [fieldListCode, setFieldListCode] = useState('');
  const [selectedCategory, setSelectedCategory] = useState({});
  const [hidden, setHidden] = useState(false);
  const [fieldList, setFieldList] = useState('');
  const [stepSuccessMessage, setStepSuccessMessage] = useState('');
  // const [field, setField] = useState(true);
  const field = true;
  const showAlertRef = useRef(false);
  const { routerPrompt, onDirty, onPristine } = useUnsavedChangesWarning();
  const { roleData } = useSelector(({ role }) => role);
  const roleDataAccessDc = roleData?.window?.['Data Calculations']?.DC;

  const [loading, setIsLoading] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  useEffect(() => {
    if (configurationUrl) {
      setIsLoading(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoading(false);
      }
      readData();
    }
  }, [configurationUrl]);

  useEffect(() => {
    if (hidden && steps.length === 3) {
      const copyArr = [...steps];
      copyArr.splice(1, 1);
      setSteps(copyArr);
    } else if (hidden === false) {
      setSteps(['Basic Info', 'Select Fields', 'Add Calculation Rules']);
    }
  }, [hidden]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    if (showAlertRef.current) {
      dispatch(
        setAlertData({
          showAlert: showAlertRef.current,
          alertCallback: () => {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
          },
        }),
      );
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };
  // useEffect(() => {
  //   if (selectedFieldList?.fieldListCode) {
  //     dispatch(fetchFieldListData(selectedFieldList?.fieldListCode));
  //   }
  // }, [selectedFieldList]);
  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };
  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
    case 0:
      return (
        <div>
          <BasicInfoRule
            setActiveStep={setActiveStep}
            setSelectedCategory={setSelectedCategory}
            selectedCategory={selectedCategory}
            handleNext={handleNext}
            hideRule={(e) => setHidden(e)}
            setFieldList={setFieldList}
            setFieldListCode={setFieldListCode}
            stepSuccessMessage={stepSuccessMessage}
            setStepSuccessMessage={setStepSuccessMessage}
            steps={steps}
            roleData={roleData}
            editExisting={editExisting}
            roleDataAccessDc={roleDataAccessDc}
            {...alertProps}
          />
        </div>
      );
    case 1:
      return (
        <div>
          <MapFieldRule
            fieldListCode={fieldListCode}
            setFieldListCode={setFieldListCode}
            handleBack={handleBack}
            handleNext={handleNext}
            fieldList={fieldList}
            setFieldList={setFieldList}
            setSelectedCategory={setSelectedCategory}
            selectedCategory={selectedCategory}
            stepSuccessMessage={stepSuccessMessage}
            setStepSuccessMessage={setStepSuccessMessage}
            steps={steps}
            field={field}
            roleData={roleData}
            roleDataAccessDc={roleDataAccessDc}
            editExisting={editExisting}
            {...alertProps}
          />
        </div>
      );
    case 2:
      return (
        <div>
          <ActionRule
            ruleAction={true}
            hidden={hidden}
            setActiveStep={setActiveStep}
            setSelectedBaseCategory={setSelectedBaseCategory}
            handleBack={handleBack}
            handleNext={handleNext}
            setValue={setValue}
            fieldListCode={fieldListCode}
            fieldList={fieldList}
            stepSuccessMessage={stepSuccessMessage}
            setStepSuccessMessage={setStepSuccessMessage}
            setFieldList={setFieldList}
            setFieldListCode={setFieldListCode}
            steps={steps}
            roleData={roleData}
            editExisting={editExisting}
            roleDataAccessDc={roleDataAccessDc}
            {...alertProps}
          />
        </div>
      );
    }
  };
  const isCurrentStepperCompleted = basicInfoData?.isDraft === 'N';
  return (
    <>
      <div className="new-standard-textfields button-table-spacing-mb justify-content-between">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => {
            if (showAlertRef.current) {
              dispatch(
                setAlertData({
                  showAlert: showAlertRef.current,
                  alertCallback: () => {
                    setValue(0);
                  },
                }),
              );
            } else {
              setValue(0);
            }
          }}
        >
          <ArrowBack className="mr-2" />
          {backButtonText}
        </Button>
        {basicInfoData?.code && (
          <div>
            <Button
              type="button"
              variant="outlined"
              className={`mx-1 search-btn ${classes.buttonRoot}`}
              // disabled={Boolean(countTotal === 0)}
              // isFreeAction= true,
              onClick={(event) => {
                dispatch(
                  postPrintUsage({
                    baseCategory: '',
                    code: basicInfoData?.code ? basicInfoData.code : '',
                    description: basicInfoData?.description ? basicInfoData.description : '',
                    displayName: basicInfoData?.displayName ? basicInfoData?.displayName : '',
                    fileType: '',
                    recordFormatType: '',
                    returnType: basicInfoData?.returnType ? basicInfoData.returnType : '',
                    isDraft: basicInfoData?.status?.key ? basicInfoData.status?.key : '',
                    sourceType: 'DATA CALCULATION',
                  }),
                );
              }}
            >
              Download Configuration Usage
            </Button>
            <Button
              type="button"
              variant="outlined"
              className={`mx-1 search-btn ${classes.buttonRoot}`}
              // disabled={Boolean(countTotal === 0)}
              onClick={() => {
                dispatch(
                  postFormulaRuleGroup({
                    code: basicInfoData?.code ? basicInfoData.code : '',
                    displayName: basicInfoData?.displayName ? basicInfoData?.displayName : '',
                    description: basicInfoData?.description ? basicInfoData.description : '',
                    returnType: basicInfoData?.returnType ? basicInfoData.returnType : '',
                    ruleType: 'FormulaRuleGroup',
                    orderBy: '',
                    orderDirection: '',
                    isDraft: basicInfoData?.status?.key ? basicInfoData.status?.key : '',
                    formulaType: basicInfoData?.formulaType?.value
                      ? basicInfoData.formulaType?.value
                      : '',
                    printIndividual: 'Y',
                    formulaRuleGroupId: basicInfoData?.groupId,
                  }),
                );
              }}
            >
              {downloadButton}
            </Button>
          </div>
        )}
      </div>
      {routerPrompt}
      <div className={classes.root} style={{ border: '1px solid #cfcfcf' }}>
        <Stepper activeStep={activeStep} connector={<QontoConnector />}>
          {steps
            .filter((e) => (hidden ? (activeStep === 2 ? e !== 'Field List' : e) : e))
            .map((label, index) => (
              <Step
                key={label}
                completed={
                  isCurrentStepperCompleted ||
                  (hidden ? index + 1 <= activeStep : index < activeStep) ||
                  undefined
                }
                onClick={(e) => {
                  if (
                    isCurrentStepperCompleted ||
                    (hidden ? index + 1 < activeStep : index < activeStep)
                  ) {
                    if (
                      showAlertRef.current &&
                      (hidden ? index !== activeStep - 1 : index !== activeStep)
                    ) {
                      dispatch(
                        setAlertData({
                          showAlert: showAlertRef.current,
                          alertCallback: () => {
                            if (hidden && label === 'Add Calculation Rules') {
                              setActiveStep(index + 1);
                            } else {
                              setActiveStep(index);
                            }
                          },
                        }),
                      );
                    } else if (index === 1 && hidden) {
                      setActiveStep(index + 1);
                    } else if (index < activeStep) {
                      setActiveStep(index);
                    } else {
                      setActiveStep(index);
                    }
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                <StepLabel
                  className={`${stepperClasses.stepperIcon} ${
                    (
                      hidden && label === 'Add Calculation Rules'
                        ? activeStep === index + 1
                        : activeStep === index
                    )
                      ? 'completedStyle'
                      : null
                  }`}
                  StepIconComponent={NumberStepIcon}
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
        </Stepper>
        <div>
          <div className={stepperClasses.stepperCard}>{getStepContent(activeStep)}</div>
        </div>
      </div>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Data Calculations'}
        name={'Data Calculation Name'}
        code={basicInfoData?.code}
        description={'Data Calculation Description'}
        descriptionValue={basicInfoData?.description}
      />
      {loading && <PageLoader />}
    </>
  );
};

export default RuleGroup1;
